import { Link } from "react-router-dom"
import { ROOT } from "../../routes/routes_name"
import useUkmPpg from "./useUkmPpg"

const UkmPpgPage = () => {
    const { } = useUkmPpg()
    return (
        <div id="body" className="index-page">
            <header id="header" className="header d-flex align-items-center fixed-top">
                <div className="header-container container-fluid container-xl position-relative d-flex align-items-center justify-content-between py-3">
                    <a href={ROOT} className="logo d-flex align-items-center me-auto me-xl-0">
                        <h1 className="sitename"><img src="../assets/img/ppg.png" alt="" srcSet="" /></h1>
                    </a>
                    <Link to={ROOT} className="btn-getstarted"><i className="bi bi-chevron-left"></i> Kembali</Link>
                </div>
            </header>
            <main className="main">
                <div className="page-title light-background">
                    <div className="container">
                        <h1>UKM PPG</h1>
                        <nav className="breadcrumbs">
                            <ol>
                                <li><a href={ROOT}>Home</a></li>
                                <li className="current">UKM PPG</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <section className="ukm-ppg section" id="ukm-ppg">
                    <div className="container">
                        <h2>UKMPPG ?</h2>
                        <div>Uji Kompetensi Mahasiwa Pendidikan Profesi Guru (UKMPPG) merupakan kegiatan tahap akhir dari rangkaian PPG yang terdiri dari dua kegiatan yaitu:</div>
                        <ol>
                            <li>Uji Kinerja (UKin)</li>
                            <li>Uji Pengetahuan (UP)</li>
                        </ol>

                        <h2>Status kepesertaan UKMPPG ?</h2>
                        <div>Berdasarkan status peserta ada dua istilah yaitu:</div>
                        <ol>
                            <li>Firsttaker, adalah peserta yang baru selesai proses PPG dan akan mengikuti UKMPPG (Ukin dan UP)</li>
                            <li>Retaker, peserta PPG yang sudah selesai proses PPG tapi belum lulus UP, UKin atau keduanya</li>
                        </ol>
                        <div className="row gx-5 gy-3">
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                <h2>Bagaimana daftar UKMPPG Firsttaker?</h2>
                                <a href="../assets/img/ukm_ppg/ukmppg_firsttaker.png" className="glightbox">
                                    <img className="card-img ukm-ppg-img" src="../assets/img/ukm_ppg/ukmppg_firsttaker.png" alt="" />
                                </a>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                <h2>Bagaimana daftar UKMPPG Retaker?</h2>
                                <a href="../assets/img/ukm_ppg/ukmppg_retaker.png" className="glightbox">
                                    <img className="card-img ukm-ppg-img" src="../assets/img/ukm_ppg/ukmppg_retaker.png" alt="" />
                                </a>
                                <span>Note : Jika peserta tidak lulus keduanya maka mengikuti kedua proses diatas </span>
                            </div>
                        </div>

                        <div className="my-3">
                            <div className="my-3"> Platform pendaftaran UKMPPG melalui tautan berikut </div>
                            <a href="https://ukm.ppg.kemdikbud.go.id/" target="_blank" className="btn btn-primary">UKMPPG</a>
                        </div>

                        <p className="mb-4">Tautan terkait :</p>
                        <ul>
                            <li className="list-border"><a target="_blank" href="https://drive.google.com/drive/folders/1RIv5960vpkW-Dc4XJSDbe7CNpldCaAkO"><i className="bi bi-check"></i> Panduan Aplikasi UP Kemenag</a></li>
                            <li className="list-border"><a target="_blank" href="#"><i className="bi bi-check"></i> Kisi-kisi Soal UP UKMPPG</a></li>
                            <li className="list-border"><a target="_blank" href="https://drive.google.com/drive/folders/1YCaqJZIgsMbqACmE45y7MtiJxPQPT7uJ"><i className="bi bi-check"></i> Kisi-kisi Soal Ukin UKMPPG</a></li>
                        </ul>
                    </div>
                </section>
            </main>
        </div>
    )
}
export default UkmPpgPage